import { Review } from '../types';

export const mockReviews: Review[] = [
  {
    id: '1',
    authorName: 'Luiz Henrique Severi',
    authorPhoto: undefined,
    rating: 5,
    comment: 'Ótimo Atendimento, Valores de locação justo, recomendo.',
    date: '2025-10-02',
    profileName: 'Aluguel de Máquinas SP',
    response: {
      id: 'r1',
      text: 'Olá Luiz, agradecemos muito pela sua avaliação positiva! Estamos felizes em saber que teve uma ótima experiência conosco.',
      date: '2025-10-03',
      isEdited: false
    }
  },
  {
    id: '2',
    authorName: 'Ruth Oliveira',
    authorPhoto: undefined,
    rating: 5,
    comment: 'Melhores aluguéis de máquinas pesadas! Serviço de excelência.',
    date: '2025-02-07',
    profileName: 'Aluguel de Máquinas SP',
    response: {
      id: 'r2',
      text: 'Obrigado pela avaliação, Ruth! Ficamos felizes em saber que você teve uma ótima experiência conosco.',
      date: '2025-02-08',
      isEdited: false
    }
  },
  {
    id: '3',
    authorName: 'Lidiane Oliveira',
    authorPhoto: undefined,
    rating: 5,
    comment: 'A melhor empresa da região oeste do Pará em aluguel de veículos e máquinas pesadas. Equipamentos modernos e profissionais qualificados para atender.',
    date: '2025-02-07',
    profileName: 'Aluguel de Máquinas SP',
  },
  {
    id: '4',
    authorName: 'Carlos Silva',
    authorPhoto: undefined,
    rating: 4,
    comment: 'Bom atendimento, mas poderia melhorar o tempo de resposta.',
    date: '2025-09-15',
    profileName: 'Aluguel de Máquinas SP',
  },
  {
    id: '5',
    authorName: 'Maria Santos',
    authorPhoto: undefined,
    rating: 5,
    comment: 'Excelente! Máquinas em ótimo estado e entrega pontual.',
    date: '2025-08-20',
    profileName: 'Aluguel de Máquinas SP',
    response: {
      id: 'r5',
      text: 'Maria, muito obrigado! Nosso compromisso é sempre entregar qualidade e pontualidade.',
      date: '2025-08-21',
      isEdited: false
    }
  },
  {
    id: '6',
    authorName: 'João Pedro',
    authorPhoto: undefined,
    rating: 3,
    comment: 'Serviço ok, mas os preços poderiam ser mais competitivos.',
    date: '2025-07-10',
    profileName: 'Aluguel de Máquinas SP',
  },
  {
    id: '7',
    authorName: 'Ana Costa',
    authorPhoto: undefined,
    rating: 5,
    comment: 'Perfeito! Sempre alugo aqui e nunca tive problemas.',
    date: '2025-06-05',
    profileName: 'Aluguel de Máquinas SP',
  },
  {
    id: '8',
    authorName: 'Roberto Lima',
    authorPhoto: undefined,
    rating: 2,
    comment: 'Máquina veio com defeito e demorou para resolver.',
    date: '2025-05-18',
    profileName: 'Aluguel de Máquinas SP',
    response: {
      id: 'r8',
      text: 'Roberto, lamentamos muito pelo ocorrido. Estamos trabalhando para melhorar nossos processos de manutenção.',
      date: '2025-05-19',
      isEdited: false
    }
  },
];
